import { createContext } from "react";
import { RegistrationId } from "../types/registration";

const RegistrationIdContext = createContext<RegistrationId | null>(null);

export default RegistrationIdContext;
